import { IContext } from '../types/context.types';

interface IDimissKeyScope {
  cid: number | string;
  aid: number | string;
  campaignId: number | string | null;
  adGroupId: number | string | null;
}

export abstract class NotificationDismissStore {
  context: IContext;
  constructor(context: IContext) {
    this.context = context;
  }


  protected abstract isKeyInDismissStorage(key: string): boolean;
  protected abstract putIntoDismissStorage(key: string, value: any): void;

  public dimissNotification(notificationId: string) {
    // eslint-disable-next-line prefer-const
    let { cid, aid, campaignId, adGroupId } = this.context.getCurrentScope().values;

    if (!adGroupId) {
      adGroupId = null;
    }
    if (!campaignId) {
      campaignId = null;
    }
    this.putIntoDismissStorage(this.buildDismissKey(notificationId, { cid, aid, campaignId, adGroupId }), 'true');
  }

  public shouldShowNotification(notificationId: string) {
    const { cid, aid, campaignId, adGroupId } = this.context.getCurrentScope().values;
    let isInDimissStorage = false;
    if (adGroupId) {
      isInDimissStorage = this.isKeyInDismissStorage(this.buildDismissKey(notificationId, {
        cid,
        aid,
        campaignId,
        adGroupId,
      }));
    }

    if (campaignId) {
      isInDimissStorage =
        isInDimissStorage ||
        this.isKeyInDismissStorage(this.buildDismissKey(notificationId, {
          cid,
          aid,
          campaignId,
          adGroupId: null,
        }));
    }

    isInDimissStorage =
      isInDimissStorage ||
      this.isKeyInDismissStorage(this.buildDismissKey(notificationId, {
        cid,
        aid,
        campaignId: null,
        adGroupId: null,
      }));

    return !isInDimissStorage;
  }

  private buildDismissKey(notificationId: string, scope: IDimissKeyScope) {
    return `cid=${scope.cid}&aid=${scope.aid}&campaignId=${scope.campaignId}&adGroupId=${
      scope.adGroupId
    }&notificationId=${notificationId}`;
  }
}

export class SessionStorageNotificationDismissStore extends NotificationDismissStore {
  sessionStorage: Storage;
  constructor(context: IContext) {
    super(context);
    this.sessionStorage = window.sessionStorage;
  }

  protected isKeyInDismissStorage(key: string) {
    return this.sessionStorage.getItem(key) !== null;
  }

  protected putIntoDismissStorage(key: string, value: any) {
    this.sessionStorage.setItem(key, value);
  }
}

export class PermanentNotificationDismissStore extends NotificationDismissStore {
  localStorage: Storage;
  constructor(context: IContext) {
    super(context);
    this.localStorage = window.localStorage;
  }

  protected isKeyInDismissStorage(key: string) {
    return this.localStorage.getItem(key) !== null;
  }

  protected putIntoDismissStorage(key: string, value: any) {
    this.localStorage.setItem(key, value);
  }
}
